import { useQuery } from '@tanstack/react-query';
import { fetchActivityData } from '@/services/adminService';
import { DateRange, ActivitySummary } from '@/types/adminActivity';

export function useAdminActivityData(dateRange: DateRange, enabled: boolean = true) {
  return useQuery<ActivitySummary, Error>({
    queryKey: ['adminActivity', dateRange.start.getTime(), dateRange.end.getTime()],
    queryFn: () => fetchActivityData(dateRange),
    enabled,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
  });
}
